export class MenuItemModal {
  constructor(i18n = null) {
    this.isVisible = false;
    this.currentItem = null;
    this.allItems = [];
    this.currentItemIndex = 0;
    this.quantity = 1;
    this.selectedModifiers = {};
    this.currentImageIndex = 0;
    this.i18n = i18n;
  }

  t(key) {
    return this.i18n ? this.i18n.t(key) : key;
  }

  show(item, allItems = null, config = null) {
    if (this.isVisible) {
      return;
    }

    this.currentItem = item;
    this.config = config;
    this.allItems = allItems || [item];
    this.currentItemIndex = this.allItems.findIndex(i => i.id === item.id);
    if (this.currentItemIndex === -1) this.currentItemIndex = 0;

    this.quantity = 1;
    this.selectedModifiers = {};
    this.currentImageIndex = 0;
    this.isVisible = true;

    this.render();

    setTimeout(() => {
      this.bindEvents();
      this.bindImageAndOtherEvents();
    }, 10);

    document.body.style.overflow = 'hidden';
  }

  hide() {
    this.isVisible = false;

    const modalContainer = document.getElementById('menu-item-modal');
    if (modalContainer) {
      modalContainer.remove();
    }

    const modalsByClass = document.querySelectorAll('.menu-item-modal-container');
    modalsByClass.forEach(modal => {
      modal.remove();
    });

    if (this.boundHandleKeyDown) {
      document.removeEventListener('keydown', this.boundHandleKeyDown);
    }
    if (this.boundHandleDocumentClick) {
      document.removeEventListener('click', this.boundHandleDocumentClick);
    }

    document.body.style.overflow = '';
  }

  render() {
    if (!this.currentItem) return;

    const modalHtml = `
      <div id="menu-item-modal" class="menu-item-modal-container">
        <div class="modal-overlay"></div>

        <div class="modal">
          <button class="modal-close" id="modal-close-btn">
            <i class="fas fa-times"></i>
          </button>

          <div class="modal-image-section">
            ${this.renderImageSection()}
          </div>

          <div class="modal-content">
            ${this.renderProductHeader()}
            ${this.renderAllergens()}
            ${this.renderModifiers()}
            ${this.renderQuantitySelector()}
            ${this.renderActionButtons()}
          </div>

          ${this.renderProductNavigation()}
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHtml);

    const modalContent = document.querySelector('.modal-content');
    if (modalContent) {
      modalContent.scrollTop = 0;
    }
  }

  renderImageSection() {
    const images = this.currentItem.images || [this.currentItem.image || null];

    return `
      <div class="modal-image-container">
        ${images[this.currentImageIndex] ?
          `<img src="${images[this.currentImageIndex]}" alt="${this.currentItem.name}" class="modal-image">` :
          `<div class="modal-image-placeholder">
            <i class="fas fa-utensils"></i>
          </div>`}

        ${images[this.currentImageIndex] ? (this.currentItem.isImageGenerated ? `
          <div class="ai-generated-watermark">
            <span class="watermark-text">ZDJĘCIE WYGENEROWANE</span>
          </div>
        ` : `
          <div class="preview-image-watermark">
            <span class="watermark-text">ZDJĘCIE POGLĄDOWE</span>
          </div>
        `) : ''}
      </div>
    `;
  }

  renderProductHeader() {
    return `
      <div class="product-header">
        <h1 class="product-name">${this.currentItem.name}</h1>
        <p class="product-description">${this.currentItem.description}</p>
      </div>
    `;
  }

  renderAllergens() {
    if (!this.currentItem.allergens || this.currentItem.allergens.length === 0) {
      return '';
    }

    return `
      <div class="allergens">
        ${this.currentItem.allergens.map(allergen => `
          <div class="allergen-tag">
            <i class="fas fa-exclamation-circle"></i>
            <span>${allergen}</span>
          </div>
        `).join('')}
      </div>
    `;
  }

  renderModifiers() {
    if (!this.currentItem.modifiers || this.currentItem.modifiers.length === 0) {
      return '';
    }

    return this.currentItem.modifiers.map(modifierGroup => `
      <div class="modifiers">
        <h2 class="section-title">${modifierGroup.name}</h2>
        <div class="modifier-options">
          ${modifierGroup.options.map(option => `
            <div class="modifier-option ${this.selectedModifiers[modifierGroup.id] === option.id ? 'selected' : ''}"
                 data-group="${modifierGroup.id}" data-option="${option.id}">
              <div class="modifier-name">
                <span>${option.name}</span>
                <span class="modifier-price">+${this.getCurrency()} ${option.price.toFixed(2)}</span>
              </div>
            </div>
          `).join('')}
        </div>
      </div>
    `).join('');
  }

  renderQuantitySelector() {
    return `
      <div class="quantity-selector">
        <span class="quantity-title">${this.t('quantity')}:</span>
        <div class="quantity-controls">
          <button class="qty-btn" id="decrease-qty" ${this.quantity <= 1 ? 'disabled' : ''}>-</button>
          <div class="quantity-value">${this.quantity}</div>
          <button class="qty-btn" id="increase-qty">+</button>
        </div>
      </div>
    `;
  }


  renderProductNavigation() {
    const hasMultipleItems = this.allItems.length > 1;
    if (!hasMultipleItems) return '';

    const prevItem = this.currentItemIndex > 0 ? this.allItems[this.currentItemIndex - 1] : null;
    const nextItem = this.currentItemIndex < this.allItems.length - 1 ? this.allItems[this.currentItemIndex + 1] : null;

    return `
      <div class="product-navigation">
        <button id="prev-product" class="product-nav-item"
                ${!prevItem ? 'disabled' : ''}>
          <i class="fas fa-arrow-left"></i>
          ${prevItem ? `
            <div class="nav-mini-image">
              ${prevItem.image ?
                `<img src="${prevItem.image}" alt="${prevItem.name}" class="nav-item-mini-image">` :
                `<div class="nav-item-image-placeholder">
                  <i class="fas fa-utensils"></i>
                </div>`}
            </div>
          ` : ''}
          <span class="nav-text">${this.t('previous')}</span>
        </button>

        <button id="next-product" class="product-nav-item"
                ${!nextItem ? 'disabled' : ''}>
          <span class="nav-text">${this.t('next')}</span>
          ${nextItem ? `
            <div class="nav-mini-image">
              ${nextItem.image ?
                `<img src="${nextItem.image}" alt="${nextItem.name}" class="nav-item-mini-image">` :
                `<div class="nav-item-image-placeholder">
                  <i class="fas fa-utensils"></i>
                </div>`}
            </div>
          ` : ''}
          <i class="fas fa-arrow-right"></i>
        </button>
      </div>
    `;
  }

  renderActionButtons() {
    return `
      <div class="action-buttons">
        <div class="price-display">${this.getCurrency()} ${this.calculateTotalPrice()}</div>

        <button id="add-to-cart-modal" class="add-to-cart">
          <i class="fas fa-plus"></i>
        </button>
      </div>
    `;
  }

  getCurrency() {
    return this.currentItem.currency || this.config?.settings?.currency || 'PLN';
  }

  calculateTotalPrice() {
    const price = typeof this.currentItem.price === 'object' ?
                  this.currentItem.price.amount :
                  this.currentItem.price;
    let total = (price || 0) * this.quantity;

    if (this.currentItem.modifiers) {
      this.currentItem.modifiers.forEach(group => {
        const selectedOptionId = this.selectedModifiers[group.id];
        if (selectedOptionId) {
          const selectedOption = group.options.find(opt => opt.id === selectedOptionId);
          if (selectedOption) {
            total += selectedOption.price * this.quantity;
          }
        }
      });
    }

    return total.toFixed(2);
  }

  bindEvents() {

    this.boundHandleDocumentClick = this.handleDocumentClick.bind(this);

    document.addEventListener('click', this.boundHandleDocumentClick);

    const modal = document.getElementById('menu-item-modal');
    if (!modal) {
      console.error('Modal not found!');
      return;
    }

    const closeBtn = modal.querySelector('#modal-close-btn');
    const overlay = modal.querySelector('.modal-overlay');

    // Note: Close button and overlay clicks are handled via document delegation in handleDocumentClick
  }

  handleDocumentClick(e) {
    if (!this.isVisible) return;

    if (e.target.id === 'modal-close-btn' || e.target.closest('#modal-close-btn')) {
      e.preventDefault();
      e.stopPropagation();
      this.hide();
      return;
    }

    if (e.target.classList.contains('modal-overlay')) {
      e.preventDefault();
      e.stopPropagation();
      this.hide();
      return;
    }

    if (e.target.id === 'decrease-qty') {
      e.preventDefault();
      e.stopPropagation();
      if (this.quantity > 1) {
        this.quantity--;
        this.updateQuantityDisplay();
        this.updatePrice();
      }
      return;
    }

    if (e.target.id === 'increase-qty') {
      e.preventDefault();
      e.stopPropagation();
      this.quantity++;
      this.updateQuantityDisplay();
      this.updatePrice();
      return;
    }

    if (e.target.id === 'add-to-cart-modal' || e.target.closest('#add-to-cart-modal')) {
      e.preventDefault();
      e.stopPropagation();
      this.addToCart();
      return;
    }
  }

  bindImageAndOtherEvents() {
    const modal = document.getElementById('menu-item-modal');
    if (!modal) return;

    const prevProductBtn = modal.querySelector('#prev-product');
    const nextProductBtn = modal.querySelector('#next-product');

    prevProductBtn?.addEventListener('click', () => this.previousProduct());
    nextProductBtn?.addEventListener('click', () => this.nextProduct());

    // Note: Quantity controls are handled via document delegation in handleDocumentClick

    const modifierOptions = modal.querySelectorAll('.modifier-option');
    modifierOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const groupId = option.dataset.group;
        const optionId = option.dataset.option;

        this.selectedModifiers[groupId] = optionId;

        const groupOptions = modal.querySelectorAll(`[data-group="${groupId}"]`);
        groupOptions.forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');

        this.updatePrice();
      });
    });


    // Note: Add to cart is handled via document delegation in handleDocumentClick

    this.boundHandleKeyDown = this.handleKeyDown.bind(this);
    document.addEventListener('keydown', this.boundHandleKeyDown);
  }

  handleKeyDown(e) {
    if (this.isVisible && e.key === 'Escape') {
      this.hide();
    }
  }


  updateImageSection() {
    const modal = document.getElementById('menu-item-modal');
    const imageSection = modal?.querySelector('.modal-image-section');
    if (imageSection) {
      imageSection.innerHTML = this.renderImageSection();
    }

    const existingNav = modal?.querySelector('.product-navigation');
    if (existingNav) {
      existingNav.outerHTML = this.renderProductNavigation();

      const prevProductBtn = modal.querySelector('#prev-product');
      const nextProductBtn = modal.querySelector('#next-product');

      prevProductBtn?.addEventListener('click', () => this.previousProduct());
      nextProductBtn?.addEventListener('click', () => this.nextProduct());
    }
  }

  updateQuantityDisplay() {
    const modal = document.getElementById('menu-item-modal');
    const quantityValue = modal?.querySelector('.quantity-value');
    const decreaseBtn = modal?.querySelector('#decrease-qty');

    if (quantityValue) {
      quantityValue.textContent = this.quantity;
    }

    if (decreaseBtn) {
      decreaseBtn.disabled = this.quantity <= 1;
    }
  }

  updatePrice() {
    const modal = document.getElementById('menu-item-modal');
    const priceElements = modal?.querySelectorAll('.product-price');

    priceElements?.forEach(element => {
      element.textContent = `${this.getCurrency()} ${this.calculateTotalPrice()}`;
    });
  }

  previousProduct() {
    if (this.currentItemIndex > 0) {
      this.currentItemIndex--;
      this.switchToItem(this.allItems[this.currentItemIndex]);
    }
  }

  nextProduct() {
    if (this.currentItemIndex < this.allItems.length - 1) {
      this.currentItemIndex++;
      this.switchToItem(this.allItems[this.currentItemIndex]);
    }
  }

  switchToItem(item) {
    this.currentItem = item;
    this.quantity = 1;
    this.selectedModifiers = {};
    this.currentImageIndex = 0;

    const modal = document.getElementById('menu-item-modal');
    if (modal) {
      const modalInner = modal.querySelector('.modal');
      if (modalInner) {
        modalInner.innerHTML = `
          <button class="modal-close" id="modal-close-btn">
            <i class="fas fa-times"></i>
          </button>

          <div class="modal-image-section">
            ${this.renderImageSection()}
          </div>

          <div class="modal-content">
            ${this.renderProductHeader()}
            ${this.renderAllergens()}
            ${this.renderModifiers()}
            ${this.renderQuantitySelector()}
            ${this.renderActionButtons()}
          </div>

          ${this.renderProductNavigation()}
        `;

        this.bindImageAndOtherEvents();

        const modalContent = modal.querySelector('.modal-content');
        if (modalContent) {
          modalContent.scrollTop = 0;
        }
      }
    }
  }

  addToCart() {
    const cartItem = {
      id: this.currentItem.id,
      name: this.currentItem.name,
      image: this.currentItem.image || this.currentItem.imageUrl,
      price: typeof this.currentItem.price === 'object' ?
             this.currentItem.price.amount :
             this.currentItem.price,
      currency: this.currentItem.currency || this.config?.settings?.currency || this.config?.currency || 'PLN',
      quantity: this.quantity,
      modifiers: this.selectedModifiers,
      totalPrice: parseFloat(this.calculateTotalPrice())
    };

    const event = new CustomEvent('itemAddedToCart', {
      detail: cartItem
    });
    document.dispatchEvent(event);

    this.hide();
  }
}